import lozad from 'lozad'
import Swiper, {Navigation, Pagination} from 'swiper'
import { header } from '../index/scripts/header';
$(document).ready(function () {
	header.init();
	portfolio.init()
})
/*==================== About - History  ====================*/
export const portfolio = {
	slide: function () {
		new Swiper('.section-portfolio-detail.section-other-projects .swiper', {
			slidesPerView: 1,
			speed: 1000,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
			modules: [Navigation, Pagination],
			pagination: {
				el: ".section-portfolio-detail.section-other-projects .swiper-pagination",
			},
			navigation: {
				nextEl: '.section-portfolio-detail.section-other-projects .btn-next',
				prevEl: '.section-portfolio-detail.section-other-projects .btn-prev',
			},
		})
	},
	init: function () {
		portfolio.slide();
	},
}

/*==================== Lazyload JS ====================*/
const observer = lozad() // lazy loads elements with default selector as '.lozad'
observer.observe()
